import React, { useState } from "react";
import { Tabs, Tab, Typography } from "@mui/material";
import { styled } from "@mui/system";

const StyledTabs = styled(Tabs)(() => ({
  width: "100%",
  border: "1px solid #A5A5A5",
  borderRadius: "6px",
  "& .MuiTabs-indicator": {
    display: "none",
  },
}));

const StyledTab = styled(Tab)(({ theme, statusColor, tabBordersColor }) => ({
  color: theme.palette.text.primary,
  "&.Mui-selected": {
    backgroundColor: statusColor ? statusColor : "#F3FDF3",
    border: tabBordersColor ? tabBordersColor : "1px solid #4CAF50",
  },
  "& .tab-content": {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
}));

const CustomTabs = ({
  numTabs,
  tabTitles,
  counts,
  onTabChange,
  tabColors,
  tabBordersColor,
  textColors,
}) => {
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    onTabChange(newValue);
    setValue(newValue);
  };

  return (
    <StyledTabs value={value} onChange={handleChange} variant="fullWidth">
      {Array.from({ length: numTabs }, (_, index) => (
        <StyledTab
          key={index}
          label={
            <div style={{ display: "flex" }} className="tab-content">
              <Typography
                variant="body1"
                className="tab-content"
                style={{
                  fontSize: "13px",
                  color:
                    textColors && textColors[index]
                      ? textColors[index]
                      : "black",
                }}
              >
                {tabTitles[index]}
              </Typography>
              {counts && (
                <Typography
                  variant="body2"
                  className="tab-content"
                  style={{
                    marginLeft: "10px",
                    color:
                      textColors && textColors[index]
                        ? textColors[index]
                        : "black",
                  }}
                >
                  {counts[index]}
                </Typography>
              )}
            </div>
          }
          selected={value === index}
          statusColor={tabColors && tabColors[index] ? tabColors[index] : null}
          tabBordersColor={
            tabBordersColor && tabBordersColor[index]
              ? tabBordersColor[index]
              : null
          }
          textColor={textColors && textColors[index] ? textColors[index] : null}
        />
      ))}
    </StyledTabs>
  );
};

export default CustomTabs;
